import { cn } from '@repo/ui/utils'

export function H1({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement> & {
  children: React.ReactNode
  className?: string
}) {
  return (
    <h1
      className={cn(
        'text-primary select-none scroll-m-20 text-3xl font-bold tracking-tight',
        className,
      )}
      {...props}
    >
      {children}
    </h1>
  )
}
